import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';
  import { t } from '@/ui/i18n/i18n';

  
export default /*#__PURE__*/_defineComponent({
  __name: 'TranslationBanner',
  props: {
    isTranslationInProgress: Boolean,
    isAiTranslation: Boolean,
  },
  setup(__props) {

const props = __props;

  

  const bannerClass = computed(() => props.isAiTranslation ? 'ai-translation-banner' : 'manual-translation-banner');

  const text = computed(
    () => props.isAiTranslation
      ? t('template-builder.translations.ai-view-banner')
      : t('template-builder.translations.manual-view-banner'),
  );

  const inProgressText = computed(
    () => props.isTranslationInProgress
      ? t('template-builder.translations.translation-in-progress').toUpperCase()
      : '',
  );

return { __sfc: true,props, bannerClass, text, inProgressText }
}

})